import { render, staticRenderFns } from "./IntegralDiagnosis.vue?vue&type=template&id=07d08cad&"
import script from "./IntegralDiagnosis.vue?vue&type=script&lang=js&"
export * from "./IntegralDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./IntegralDiagnosis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports